import { CheckedStateRadioGroup } from '@udemy/react-checked-state-components';
import classNames from 'classnames';
import React from 'react';
import { WAIT_FOR_CSS_TRANSITIONS } from '../side-drawer/helpers';
import styles from "../side-drawer/side-drawer.module.css";
import { SideDrawerContext } from '../side-drawer/side-drawer.react-component';
/** React props interface for SideDrawerRadio component */

/**
 * SideDrawerRadio component
 * @internal
 */
export const SideDrawerRadio = radioProps => {
  /** Internally used to access the parent SideDrawers. */
  const sideDrawerRef = React.useContext(SideDrawerContext);

  const onChange = event => {
    const {
      onChange
    } = radioProps;
    setTimeout(() => {
      if (event.target.dataset.checked) {
        const dialogInstance = sideDrawerRef.current;
        const firstFocusable = dialogInstance === null || dialogInstance === void 0 ? void 0 : dialogInstance.findFirstFocusable();
        firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
      }
    }, WAIT_FOR_CSS_TRANSITIONS);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };

  return /*#__PURE__*/React.createElement(CheckedStateRadioGroup.Radio, Object.assign({}, radioProps, {
    className: classNames('js-drawer-radio', styles['drawer-radio']),
    onChange: onChange
  }));
};
//# sourceMappingURL=side-drawer-radio.react-component.js.map